import { render } from "./NewsfeedDialog.vue?vue&type=template&id=44823f12"
import script from "./NewsfeedDialog.vue?vue&type=script&lang=js"
export * from "./NewsfeedDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__